import { Blog20210227_NewSite_Short } from "./Blog20210227_NewSite";
import { INewsItemData } from "./NewsData";

//List of all the news summaries
export let newsList: ReadonlyArray<INewsItemData> = [Blog20210227_NewSite_Short]
